module.exports = __webpack_public_path__ + "img/seat-1.54f78a3d.jpg";